import { Component, Input, OnChanges } from "@angular/core";
import { Facet, FacetValue, GetProductDetailQuery, GetProductVariantDetailQuery } from '../../common/gql/graphql';
import { RouterLink } from "@angular/router";
import { NgIf, NgFor } from "@angular/common";

type BrandFacetValue = Pick<FacetValue, 'name' | 'code' >;
type BrandFacetValueInput = {
    facetValues: Array<BrandFacetValue & { facet: Pick<Facet, 'code'> }>;
};

@Component({
    selector: 'kb-brand-label',
    templateUrl: './brand-label.component.html',
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        RouterLink,
    ],
})
export class BrandLabelComponent implements OnChanges {
    @Input() product: BrandFacetValueInput | undefined;
    brandFacetValues: BrandFacetValue[] = [];
    ngOnChanges() {
        if (this.product) {
            this.brandFacetValues = this.product.facetValues.filter((fv) => fv.facet.code === 'brand');
        }
    }
}
